import type { IconSvgObject } from './types';

const TumblrIcon: IconSvgObject = [
  ["path", { d: "M14 2H10.5027C9.91641 5.87594 7.28571 7.09109 6 7.53255V11H9L9.03413 16.1372C9.03413 17.9296 9.50221 18.8487 9.85771 19.4493C11.9622 23.0048 16.2888 22.1375 18 21.0381L16.994 17.6744C14.7803 18.3404 14 17.5 14 16.5V11H17.5V7.59449H14V2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TumblrIcon;
